import { render } from "./ItemDetail.vue?vue&type=template&id=1b34f865&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"

import "./ItemDetail.vue?vue&type=style&index=0&id=1b34f865&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b34f865"]])

export default __exports__